import * as React from 'react';
import { Route, Switch } from 'react-router';
import { TournamentsUpcoming } from './TournamentsUpcoming/TournamentsUpcoming';
import { TournamentsArchive } from './TournamentsArchive/TournamentsArchive';
import { TournamentNotifications } from './TournamentNotifications';
import { TournamentParticipants } from './TournamentParticipants';
import { TournamentEligibleSchools } from './TournamentEligibleSchools';
import { TournamentAthleteSchools } from './TournamentAthleteSchools';
import { TournamentWaitingList } from './TournamentWaitingList';
import { TournamentConfirmationRequests } from './TournamentConfirmationRequests';
import { SchoolUnionTournamentEvents } from './TournamentEvents';
import { TournamentAdmins } from './TournamentAdmins';
import { TournamentCustomGroups } from './TournamentCustomGroups';
import { TournamentPitches } from './TournamentPitches';
import { TournamentEnrolledLogs } from './TournamentEnrolledLogs';
import { CreateTournamentCustomNotificationsView } from './CreateTournamentCustomNotificationsView/CreateTournamentCustomNotificationsView';
import { TournamentParticipants2 } from './TournamentParticipants2';
import { TournamentManagement } from './TournamentManagement/TournamentManagement';
import { TournamentCommunicationsInbox } from './TournamentCommunicationsInbox';
import { TournamentCompetitionStructurePage } from './TournamentManagement/TournamentCompetitionStructurePage';
import { TournamentSchoolNotificationComposer } from './TournamentManagement/TournamentSchoolNotificationComposer';
import { AdminSUTournamentTeams } from './TournamentTeams/TournamentTeams';
import { TournamentView } from './TournamentForm/TournamentView';
import AdminSUTournamentGrid from './TournamentGrid/TournamentGrid';
import { SchoolUnionEventView } from './TournamentEvent/SchoolUnionEventView';
import TournamentTeamPlayers from './TournamentTeamPlayers/TournamentTeamPlayers';
import { AdminSUInvitesOutbox } from '../Invites/InvitesOutbox';
import { AdminSUInvitesArchive } from '../Invites/InvitesArchive';
import { Redirect } from 'react-router';
import '../../AdminView/Invites/SchoolInvitesHub.scss';
import { UnionTournamentsListHeader } from './UnionTournamentsListHeader';
import { UnionTournamentRoutePageHelp } from './UnionTournamentRoutePageHelp';

const UnionInvitesHub = allProps => {
  const pathname = allProps.location.pathname;
  return (
    <div className="schoolInvitesHub unionTournamentsModern unionTournamentsListShell">
      <UnionTournamentsListHeader
        user={allProps.user}
        history={allProps.history}
        activeSection="invites"
        onAddTournament={() =>
          allProps.history.push({
            pathname: '/tournaments/tournamentView',
            state: { prevPath: pathname }
          })
        }
      />
      <div className="schoolInvitesHub__content">
        {pathname.endsWith('/archive') ? (
          <AdminSUInvitesArchive {...allProps} user={allProps.user} />
        ) : (
          <AdminSUInvitesOutbox {...allProps} user={allProps.user} />
        )}
      </div>
    </div>
  );
};

export const TournamentRouting = allProps => {
  return (
    <>
      <UnionTournamentRoutePageHelp location={allProps.location} history={allProps.history} />
      <Switch>
      <Route exact path={'/tournaments/invites'} render={() => <Redirect to="/tournaments/invites/outbox" />} />
      <Route
        exact
        path={'/tournaments/communications'}
        render={props => <TournamentCommunicationsInbox {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={['/tournaments/invites/outbox', '/tournaments/invites/archive']}
        render={props => <UnionInvitesHub {...props} user={allProps.user} />}
      />
      <Route
        exact
        key="upcoming"
        path={'/tournaments/upcoming'}
        render={props => <TournamentsUpcoming {...props} user={allProps.user} />}
      />
      <Route
        exact
        key="archive"
        path={'/tournaments/archive'}
        render={props => <TournamentsArchive {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/tournamentView'}
        render={props => <TournamentView {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/notifications'}
        render={props => <TournamentNotifications {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/notifications/send'}
        render={props => <CreateTournamentCustomNotificationsView {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/manage/entries/athleteSchools/notification'}
        render={props => <TournamentSchoolNotificationComposer {...props} user={allProps.user} audienceContext="organiserRepresented" />}
      />
      <Route
        exact
        path={'/tournaments/manage/entries/eligible/notification'}
        render={props => <TournamentSchoolNotificationComposer {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/manage/competition/structure'}
        render={props => <TournamentCompetitionStructurePage {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/manage/:section?/:subsection?'}
        render={props => <TournamentManagement {...props} user={allProps.user} />}
      />
      <Route exact path={'/tournaments/athleteSchools/notification'}
        render={props => <TournamentSchoolNotificationComposer {...props} user={allProps.user} audienceContext="organiserRepresented" />} />
      <Route
        exact
        path={'/tournaments/participants'}
        render={props => <TournamentParticipants2 {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/confirmationRequests/send'}
        render={props => <TournamentParticipants {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/eligibleSchools'}
        render={props => <TournamentEligibleSchools {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/athleteSchools'}
        render={props => <TournamentAthleteSchools {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/confirmationRequests'}
        render={props => <TournamentConfirmationRequests {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/waitingList'}
        render={props => <TournamentWaitingList {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/pitches'}
        render={props => <TournamentPitches {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/events'}
        render={props => <SchoolUnionTournamentEvents {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/events/event'}
        render={props => <SchoolUnionEventView {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/admins'}
        render={props => <TournamentAdmins {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/customGroups'}
        render={props => <TournamentCustomGroups {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/logs'}
        render={props => <TournamentEnrolledLogs {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/teams'}
        render={props => <AdminSUTournamentTeams {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/teams/members'}
        render={props => <TournamentTeamPlayers {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/grid'}
        render={props => <AdminSUTournamentGrid {...props} user={allProps.user} />}
      />
      </Switch>
    </>
  );
};

TournamentRouting.displayName = 'TournamentRouting';
